export default "__VITE_ASSET__Bbq9BWIz__"